import { render } from "./EditUnitDetails.vue?vue&type=template&id=d8c51646&scoped=true"
import script from "./EditUnitDetails.vue?vue&type=script&lang=js"
export * from "./EditUnitDetails.vue?vue&type=script&lang=js"

import "./EditUnitDetails.vue?vue&type=style&index=0&id=d8c51646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c51646"]])

export default __exports__